// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".KOlogTDxpsK8p1F_nyHW {\n\tmargin: 0;\n\tpadding: 0;\n\theight: auto;\n}\n", "",{"version":3,"sources":["webpack://./client/src/components/styles/LinkButton.module.css"],"names":[],"mappings":"AAAA;CACC,SAAS;CACT,UAAU;CACV,YAAY;AACb","sourcesContent":[".linkButton {\n\tmargin: 0;\n\tpadding: 0;\n\theight: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkButton": "KOlogTDxpsK8p1F_nyHW"
};
export default ___CSS_LOADER_EXPORT___;
